// data-testid registry for the Discovery flow (Q1 → Q6 → Summary → Sign-in → Recommendation)
export const DISCOVERY = {
  root: "discovery-root",
  step: "discovery-step",
  questionTitle: "discovery-question-title",
  input: "discovery-input",
  optionChip: "discovery-option-chip",
  primaryCta: "discovery-primary-cta",
  backBtn: "discovery-back",
  producerLine: "discovery-producer-line",

  summary: "discovery-summary",
  summaryRow: "discovery-summary-row",
  summaryEdit: "discovery-summary-edit",
  summaryContinue: "discovery-summary-continue",

  signinWall: "discovery-signin-wall",
  signinBtn: "discovery-signin-btn",

  recommendation: "discovery-recommendation",
  recHeadline: "discovery-rec-headline",
  recBudget: "discovery-rec-budget",
  recTimeline: "discovery-rec-timeline",
  recBestWay: "discovery-rec-bestway",
  recNext: "discovery-rec-next",
  recSaveCta: "discovery-rec-save-cta",
};
